import { useSetupGuideState } from '../pages/SetupGuide/hooks/useSetupGuideState';

export interface AdminSetupBeaconNextStep {
  key: string;
  title: string;
}

export interface AdminSetupBeaconState {
  completedCount: number;
  totalCount: number;
  fractionDone: number;
  nextStep: AdminSetupBeaconNextStep | null;
  isFullySetup: boolean;
  loading: boolean;
}

export function useAdminSetupBeacon(): AdminSetupBeaconState {
  const { items, completedCount, totalCount, loading } = useSetupGuideState();
  const fractionDone = totalCount > 0 ? completedCount / totalCount : 0;
  const isFullySetup = totalCount > 0 && completedCount === totalCount;
  const next = items.find(item => !item.result.complete && !item.blocked);
  const nextStep = next ? { key: next.config.key, title: next.config.title } : null;

  return {
    completedCount,
    totalCount,
    fractionDone,
    nextStep,
    isFullySetup,
    loading,
  };
}
